export default __webpack_public_path__ + "static/media/antp_CartaPorteV2_CuadroWEB_.2199b51f.jpg";